<template>
  <div id="RechargeOfferView" class="recharge-offer-view">
    <b-form id="recharge-offer-form" @submit.prevent="save" class="add-news-form pt-3">
      <b-form-row>
        <b-col sm="9">
          <h5>Off Period</h5>
          <b-form-group id="recharge-welcome-offer-hero" label="Hero image url" labelFor="recharge-welcome-offer-hero-input" class="recharge-form-label" description="Enter comlete Imgix URL">
            <b-form-input id="recharge-welcome-offer-hero-input" v-model="rechargeWelcomeOffer.hero" name="recharge-welcome-offer-hero-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-hero-top" label="Hero top" labelFor="recharge-welcome-offer-hero-top-input" class="recharge-form-label" description="Smaller text displayed above hero title">
            <b-form-input id="recharge-welcome-offer-hero-top-input" v-model="rechargeWelcomeOffer.heroTop" name="recharge-welcome-offer-hero-top-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-hero-h1" label="Hero h1" labelFor="recharge-welcome-offer-hero-h1-input" class="recharge-form-label">
            <b-form-input id="recharge-welcome-offer-hero-h1-input" v-model="rechargeWelcomeOffer.heroH1" name="recharge-welcome-offer-hero-h1-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-hero-h2" label="Hero h2" labelFor="recharge-welcome-offer-hero-h2-input" class="recharge-form-label">
            <b-form-input id="recharge-welcome-offer-hero-h2-input" v-model="rechargeWelcomeOffer.heroH2" name="recharge-welcome-offer-hero-h2-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-hero-recharge" label="Recharge text" labelFor="recharge-welcome-offer-hero-recharge-input" class="recharge-form-label">
            <b-form-input id="recharge-welcome-offer-hero-recharge-input" v-model="rechargeWelcomeOffer.rechargeText" name="recharge-welcome-offer-hero-recharge-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="1"></b-col>
        <b-col sm="2">
          <b-form-group id="recharge-language" label="Select a language" labelFor="recharge-language-select" class="recharge-language-label">
            <multiselect id="recharge-language-select" v-model="locale" :options="languages" label="name" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col sm="9">
          <h5>Promo Period</h5>
          <b-form-group id="recharge-welcome-offer-promo-hero" label="Hero image url" labelFor="recharge-welcome-offer-promo-hero-input" class="recharge-form-label" description="Enter comlete Imgix URL">
            <b-form-input id="recharge-welcome-offer-promo-hero-input" v-model="rechargeWelcomeOffer.promoHero" name="recharge-welcome-offer-promo-hero-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-promo-hero-top" label="Hero top" labelFor="recharge-welcome-offer-promo-hero-top-input" class="recharge-form-label" description="Smaller text displayed above hero title">
            <b-form-input id="recharge-welcome-offer-promo-hero-top-input" v-model="rechargeWelcomeOffer.promoHeroTop" name="recharge-welcome-offer-promo-hero-top-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-promo-hero-h1" label="Hero h1" labelFor="recharge-welcome-offer-promo-hero-h1-input" class="recharge-form-label">
            <b-form-input id="recharge-welcome-offer-promo-hero-h1-input" v-model="rechargeWelcomeOffer.promoHeroH1" name="recharge-welcome-offer-promo-hero-h1-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-promo-hero-h2" label="Hero h2" labelFor="recharge-welcome-offer-promo-hero-h2-input" class="recharge-form-label">
            <b-form-input id="recharge-welcome-offer-promo-hero-h2-input" v-model="rechargeWelcomeOffer.promoHeroH2" name="recharge-welcome-offer-promo-hero-h2-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-promo-hero-fineprint" label="Hero fineprint" labelFor="recharge-welcome-offer-promo-hero-fineprint-input" class="recharge-form-label" description="Promo period date range e.g. Valid June 25 - June 30">
            <b-form-input id="recharge-welcome-offer-promo-hero-fineprint-input" v-model="rechargeWelcomeOffer.promoHeroFineprint" name="recharge-welcome-offer-promo-hero-fineprint-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-promo-hero-recharge" label="Recharge text" labelFor="recharge-welcome-offer-promo-hero-recharge-input" class="recharge-form-label">
            <b-form-input id="recharge-welcome-offer-promo-hero-recharge-input" v-model="rechargeWelcomeOffer.promoRechargeText" name="recharge-welcome-offer-promo-hero-recharge-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col sm="9">
          <h5>Prebook period</h5>
          <b-form-group id="recharge-welcome-offer-prebook-hero" label="Hero image url" labelFor="recharge-welcome-offer-prebook-hero-input" class="recharge-welcome-offer-form-label" description="Enter comlete Imgix URL">
            <b-form-input id="recharge-welcome-offer-prebook-hero-input" v-model="rechargeWelcomeOffer.prebookHero" name="recharge-welcome-offer-prebook-hero-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-prebook-hero-top" label="Hero top" labelFor="recharge-welcome-offer-prebook-hero-top-input" class="recharge-welcome-offer-form-label" description="Smaller text displayed above hero title">
            <b-form-input id="recharge-welcome-offer-prebook-hero-top-input" v-model="rechargeWelcomeOffer.prebookHeroTop" name="recharge-welcome-offer-prebook-hero-top-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-prebook-hero-h1" label="Hero h1" labelFor="recharge-welcome-offer-prebook-hero-h1-input" class="recharge-welcome-offer-form-label">
            <b-form-input id="recharge-welcome-offer-prebook-hero-h1-input" v-model="rechargeWelcomeOffer.prebookHeroH1" name="recharge-welcome-offer-prebook-hero-h1-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-prebook-hero-h2" label="Hero h2" labelFor="recharge-welcome-offer-prebook-hero-h2-input" class="recharge-welcome-offer-form-label">
            <b-form-input id="recharge-welcome-offer-prebook-hero-h2-input" v-model="rechargeWelcomeOffer.prebookHeroH2" name="recharge-welcome-offer-prebook-hero-h2-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-prebook-hero-fineprint" label="Hero fineprint" labelFor="recharge-welcome-offer-prebook-hero-fineprint-input" class="recharge-welcome-offer-form-label" description="Promo period date range e.g. Valid June 25 - June 30">
            <b-form-input id="recharge-welcome-offer-prebook-hero-fineprint-input" v-model="rechargeWelcomeOffer.prebookHeroFineprint" name="recharge-welcome-offer-prebook-hero-fineprint-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-welcome-offer-prebook-hero-recharge" label="Recharge text" labelFor="recharge-welcome-offer-prebook-hero-recharge-input" class="recharge-form-label">
            <b-form-input id="recharge-welcome-offer-prebook-hero-recharge-input" v-model="rechargeWelcomeOffer.prebookRechargeText" name="recharge-welcome-offer-prebook-hero-recharge-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="submit">
        <b-col cols="12" sm="12">
          <b-button type="submit" size="lg" variant="primary" :disabled="isLoading">Save</b-button>
        </b-col>
      </b-form-row>
    </b-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import WebContentLeftNav from '@/components/layout/WebContentLeftNav'
import Header from '@/components/layout/Header'
export default {
  name: 'RechargeOffer',
  components: {
    WebContentLeftNav,
    Header
  },
  async mounted () {
    await this.loadByLocale()
  },
  methods: {
    ...mapActions({
      'fetchRechargeWelcomeOffer': 'recharge/fetchRechargeWelcomeOffer',
      'saveRechargeWelcomeOffer': 'recharge/saveRechargeWelcomeOffer'
    }),
    async loadByLocale () {
      await this.fetchRechargeWelcomeOffer(this.locale.id)
      let r = this.$store.state.recharge.rechargeWelcomeOffer
      this.rechargeWelcomeOffer = Object.assign({}, r)
    },
    save () {
      this.saveRechargeWelcomeOffer(this.locale.id).then(() => {
        this.$toastr.s('Recharge Welcome Offer saved')
      }).catch((error) => {
        this.$toastr.e(error)
      })
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'loader/isLoading'
    })
  },
  watch: {
    locale: {
      handler (newValue) {
        if (newValue.id !== undefined) {
          this.locale = newValue
          this.loadByLocale()
        }
      }
    },
    rechargeWelcomeOffer: {
      handler (newValue) {
        this.$store.dispatch('recharge/setRechargeWelcomeOffer', newValue)
      },
      deep: true
    }
  },
  data () {
    return {
      locale: {id: 'en', name: 'English'},
      rechargeWelcomeOffer: {},
      languages: [{id: 'en', name: 'English'}, {id: 'es', name: 'Spanish'}, {id: 'fr', name: 'French'}]
    }
  }
}
</script>
<style lang="scss" scoped>

.has-error {
  color: #ff0000;
  input {
    border-color: #ff0000;
  }
}
.submit{
  margin-top: 20px;
}

h5{
  margin-bottom: 20px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/recharge/Offer.vue